module.exports = require('./src/atrament.js');


/** WEBPACK FOOTER **
 ** ./index.js
 **/